import api from "../../services/api";
import {
  CREATE_WASH_FAILURE,
  CREATE_WASH_REQUEST,
  CREATE_WASH_SUCCESS,
  GET_CAR_WASH_BY_CUSTOMER_FAILURE,
  GET_CAR_WASH_BY_CUSTOMER_REQUEST,
  GET_CAR_WASH_BY_CUSTOMER_SUCCESS,
  GET_FILTERED_WASHES_FAILURE,
  GET_FILTERED_WASHES_REQUEST,
  GET_FILTERED_WASHES_SUCCESS,
  GET_WASHES_FAILURE,
  GET_WASHES_REQUEST,
  GET_WASHES_SUCCESS,
  UPDATE_WASH_REQUEST,
  UPDATE_WASH_SUCCESS,
} from "./ActionType";

const createWashRequest = () => {
  return {
    type: CREATE_WASH_REQUEST,
  };
};

const createWashSuccess = (wash) => {
  return {
    type: CREATE_WASH_SUCCESS,
    payload: wash,
  };
};

const createWashFailure = (error) => {
  return {
    type: CREATE_WASH_FAILURE,
    payload: error,
  };
};

export const createWash = (input) => async (dispatch) => {
  dispatch(createWashRequest());
  try {
    const response = await api.post(`/wash/${input.bookingId}`, input.wash, {
      withCredentials: true,
    });
    dispatch(createWashSuccess(response.data));
    console.log(response.data);
    window.location.reload(false);
  } catch (error) {
    input.setErrorMessage("Failed to create wash");
    dispatch(createWashFailure(error));
  }
};

const getAllWashesRequest = () => ({
  type: GET_WASHES_REQUEST,
});

const getAllWashesSuccess = (washes) => ({
  type: GET_WASHES_SUCCESS,
  payload: washes,
});

const getAllWashesFailure = (error) => ({
  type: GET_WASHES_FAILURE,
  payload: error,
});

export const getAllWashes = () => async (dispatch) => {
  dispatch(getAllWashesRequest());
  try {
    const response = await api.get("/wash", { withCredentials: true });
    dispatch(getAllWashesSuccess(response.data));
  } catch (error) {
    dispatch(getAllWashesFailure(error));
  }
};

const updateWashRequest = () => {
  return {
    type: UPDATE_WASH_REQUEST,
  };
};

const updateWashSuccess = (wash) => {
  return {
    type: UPDATE_WASH_SUCCESS,
    payload: wash,
  };
};

const updateWashFailure = (error) => {
  return {
    type: CREATE_WASH_FAILURE,
    payload: error,
  };
};

export const updateWash = (input) => async (dispatch) => {
  dispatch(updateWashRequest());
  try {
    const response = await api.put(`/wash/${input.bookingId}`, input.wash, {
      withCredentials: true,
    });
    dispatch(updateWashSuccess(response.data));
    console.log(response.data);
    window.location.reload(false);
  } catch (error) {
    input.setErrorMessage("Failed to update wash");
    dispatch(updateWashFailure(error));
  }
};

export const getFilteredWashRequest = () => {
  return {
    type: GET_FILTERED_WASHES_REQUEST,
  };
};

export const getFilteredWashSuccess = (washes) => {
  return {
    type: GET_FILTERED_WASHES_SUCCESS,
    payload: washes,
  };
};

export const getFilteredWashFailure = (error) => {
  return {
    type: GET_FILTERED_WASHES_FAILURE,
    payload: error,
  };
};

export const getFilteredWashes = (filter) => async (dispatch) => {
  dispatch(getFilteredWashRequest());
  try {
    const response = await api.get(`/wash/filter${filter}`, {
      withCredentials: true,
    });
    dispatch(getFilteredWashSuccess(response.data));
  } catch (error) {
    dispatch(getFilteredWashFailure(error));
  }
};

const getCarWashByCustomerRequest = () => {
  return {
    type: GET_CAR_WASH_BY_CUSTOMER_REQUEST,
  };
};

const getCarWashByCustomerSuccess = (washes) => {
  return {
    type: GET_CAR_WASH_BY_CUSTOMER_SUCCESS,
    payload: washes,
  };
};

const getCarWashByCustomerFailure = (error) => {
  return {
    type: GET_CAR_WASH_BY_CUSTOMER_FAILURE,
    payload: error,
  };
};

export const getCarWashByCustomer = (filter) => async (dispatch) => {
  dispatch(getCarWashByCustomerRequest());
  try {
    const response = await api.get(`/wash/by-customer${filter}`, {
      withCredentials: true,
    });
    dispatch(getCarWashByCustomerSuccess(response.data));
  } catch (error) {
    dispatch(getCarWashByCustomerFailure(error));
  }
};
